import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import * as styles from './Label.style';
export const Label = _ref => {
  let {
    text,
    inline,
    required = false,
    dataRef = 'label',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledLabel, _extends({
    "data-ref": dataRef,
    $inline: inline
  }, rest, {
    $_css: styles.main
  }), text, required && /*#__PURE__*/React.createElement(_StyledSup, {
    $_css2: styles.requiredAsterisk
  }, " *"));
};
export default Label;
var _StyledLabel = _styled("label").withConfig({
  displayName: "Label___StyledLabel",
  componentId: "sc-p6m2ua-0"
})(["", ""], p => p.$_css);
var _StyledSup = _styled("sup").withConfig({
  displayName: "Label___StyledSup",
  componentId: "sc-p6m2ua-1"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=Label.js.map